import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 max-w-3xl mx-auto">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
              {appInfo.title}
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
              {appInfo.desc}
            </p>
            <div className="mt-5 flex flex-wrap justify-center lg:justify-start gap-2">
              {appInfo.features.map((f, i) => (
                <span
                  key={i}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-background-100 text-xs text-foreground-700 rounded-full whitespace-nowrap"
                >
                  <i className="ri-check-line text-primary-500 text-sm"></i>
                  {f}
                </span>
              ))}
            </div>
          </div>
          <div className="w-40 h-40 md:w-48 md:h-48 rounded-xl overflow-hidden bg-background-100 border border-background-200/60 flex-shrink-0">
            <img
              src={appInfo.qrImg}
              alt="在线吃瓜公众号二维码"
              className="w-full h-full object-cover"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}